import {
  Accordion,
  AccordionSummary,
  Typography,
  AccordionDetails,
  Tooltip,
  List,
  ListItem,
  ListItemText
} from '@mui/material';
import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import BadgeNumber from 'components/BadgeNumber';
import FormBuilder from './FormBuilder';
import { Form2Section3Fields } from 'constants/form-2-section-3-fields';
import CircularIcon from 'components/CircularIcon';
import DoneIcon from '@mui/icons-material/Done';
import InfoIcon from '@mui/icons-material/Info';
import { useController } from 'react-hook-form';
import BottomButton from 'components/BottomButton';

const BENEFICIAL_OWNER_DISCLAIMER = [
  'Seorang yang memiliki hak dan/atau menerima manfaat tertentu yang berkaitan dengan transaksi pengguna jasa keuangan, baik secara langsung maupun tidak langsung.',
  'Pemilik sebenarnya dari harta kekayaan yang berkaitan dengan transaksi pengguna jasa keuangan.',
  'Pengendali atas transaksi pengguna jasa keuangan.',
  'Pemberi kuasa untuk melakukan transaksi.',
  'Pengendali korporasi/perusahaan.',
  'Pengendali terakhir dari transaksi yang dilakukan melalui korporasi/perusahaan atau berdasarkan suatu perjanjian'
];

export default function FormStep2Section3Container() {
  const [searchParams] = useSearchParams();
  const section = searchParams.get('section') || '1';
  const [isAccordionExpanded, setIsAccordionExpanded] = useState(false);
  const { fieldState, formState } = useController({ name: 'entity.beneficial_owner' });

  useEffect(() => {
    setIsAccordionExpanded(section === '3');
  }, [section]);

  useEffect(() => {
    if (fieldState.error) {
      setIsAccordionExpanded(true);
    }
  }, [fieldState.error]);

  return (
    <Accordion
      expanded={isAccordionExpanded}
      onChange={() => ['3'].includes(section) && setIsAccordionExpanded((prev) => !prev)}
    >
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        {section <= '3' ? (
          <BadgeNumber>3</BadgeNumber>
        ) : (
          <CircularIcon>
            <DoneIcon />
          </CircularIcon>
        )}
        <Typography color="surface.700" variant="h6" sx={{ marginLeft: 1 }}>
          Beneficial Owner/Ultimate Shareholder
        </Typography>
        <Tooltip
          arrow
          placement="top"
          title={
            <List sx={{ listStyle: 'decimal', pl: 2, py: 0 }}>
              {BENEFICIAL_OWNER_DISCLAIMER.map((text) => (
                <ListItem key={text} sx={{ display: 'list-item', py: 0 }}>
                  <ListItemText primary={text} />
                </ListItem>
              ))}
            </List>
          }
          componentsProps={{
            tooltip: {
              sx: {
                maxWidth: 500
              }
            }
          }}
        >
          <InfoIcon fontSize="small" sx={{ mt: 0.5, ml: 1, color: 'surface.300' }} />
        </Tooltip>
      </AccordionSummary>
      <AccordionDetails>
        {['3'].includes(section) && <FormBuilder formFields={Form2Section3Fields()} />}
      </AccordionDetails>
      {section === '3' && <BottomButton isButtonLoading={formState.isSubmitting} />}
    </Accordion>
  );
}
